document.querySelectorAll('.bs-bel').forEach(function(sec){
  var track = sec.querySelector('[data-bs-bel-track]');
  if(!track) return;
  sec.querySelectorAll('.bs-bel__arrow').forEach(function(btn){
    btn.addEventListener('click', function(){
      var dir = btn.getAttribute('data-dir') === 'next' ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    });
  });
});
